import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "subtotalDisplay",
    "subtotalForm",
    "subtotalInput",
    "subtotalButton",
    "errors",
  ];
  static values = { feeGuid: String };

  async showQuickLook(event) {
    event.preventDefault();
    await this.render(event.currentTarget.dataset.feeGuid);
  }

  closeQuickLook(event) {
    event.preventDefault();
    const quickLook = document.querySelector("#school-payment-quick-look");
    if (quickLook) {
      quickLook.classList.add("u-hidden");
      quickLook.innerHTML = "";
    }
  }

  editSubtotal(event) {
    event.preventDefault();
    this.hideError();
    this.subtotalDisplayTarget.classList.add("u-hidden");
    this.subtotalFormTarget.classList.remove("u-hidden");
    this.subtotalInputTarget.focus();
    this.subtotalInputTarget.select();
  }

  cancelSubtotal(event) {
    event.preventDefault();
    this.hideError();
    this.subtotalFormTarget.classList.add("u-hidden");
    this.subtotalDisplayTarget.classList.remove("u-hidden");
  }

  async saveSubtotal(event) {
    event.preventDefault();
    this.subtotalButtonTarget.disabled = true;
    this.hideError();

    const response = await fetch(`/schools/fees/${this.feeGuidValue}/quick-look/subtotal`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ amount: this.subtotalInputTarget.value }),
    });
    const body = await response.json().catch(() => ({}));

    if (!response.ok) {
      this.showError(body.error || "Unable to change this subtotal.");
      this.subtotalButtonTarget.disabled = false;
      return;
    }

    // Re-render in place rather than closing, so the new subtotal, due amount and
    // status are visible straight away; the table behind refreshes to match.
    window.dispatchEvent(new CustomEvent("driving-school-student-payments-v2:refresh"));
    await this.render(this.feeGuidValue);
  }

  async render(feeGuid) {
    const response = await fetch(`/schools/fees/${feeGuid}/quick-look/edit`, {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
    });

    if (!response.ok) {
      alert("Unable to load fee actions right now.");
      return;
    }

    const quickLook = document.querySelector("#school-payment-quick-look");
    if (!quickLook) {
      alert("Quick look container not found.");
      return;
    }

    quickLook.classList.remove("u-hidden");
    const documentBody = new DOMParser().parseFromString(await response.text(), "text/html").body;
    quickLook.innerHTML = "";
    quickLook.appendChild(documentBody);
  }

  showError(message) {
    if (!this.hasErrorsTarget) return;
    this.errorsTarget.textContent = message;
    this.errorsTarget.classList.remove("u-hidden");
  }

  hideError() {
    if (!this.hasErrorsTarget) return;
    this.errorsTarget.textContent = "";
    this.errorsTarget.classList.add("u-hidden");
  }
}
